import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawContainerModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Container");

		this.name = "container";
		this.icon = svg_container;
		this.svgTextIndex = 1;
	}
}

window.customElements.define("inspx-draw-container-module", DrawContainerModule);

const svg_container = (text) => html`
<svg width="90" height="45.00000000000001" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
<g>
 <title>Layer 1</title>
 <rect stroke="black" fill="#ffff00" stroke-width="1px" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="0.94922" y="0.70715" width="88" height="44.30244" id="svg_4" rx="1" ry="1"/>
 <text font-weight="bold" transform="matrix(0.7542733415985815,0,0,0.7770136006077655,146.96019406007855,-131.23428258853747) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_1" y="206.64939" x="-134.93358" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000" stroke="black">${text}</text>
</g>
</svg>
`;
